import AppContent from 'js/components/AppContent';
import { makeRequest } from 'js/services/Network';
import React, { useState } from 'react';

const StatusItem = ({ title, value }) => (
  <div className="status-item d-flex align-items-center justify-content-start">
    <div className="title pe-2 font-weight-bold" style={{ width: '40%' }}>{title}:</div>
    <div className="value">{value}</div>
  </div>
);

const GokadaStatusPage = ({ alias, ...other }) => {
  const [status, setStatus] = useState({});

  // Get the search params mode and otp from other.location
  const searchParams = new URLSearchParams(other.location.search);

  React.useEffect(() => {
    makeRequest('status-data-gokada', { alias: alias })
      .then(({ data }) => {
        setStatus(data);
      });
  }, []);

  React.useEffect(() => {
    if (status && status.url) {
      setTimeout(() => {
        redirectNow(status.url);
      }, 1000);
    }
  }, [status]);

  const redirectNow = (url) => {
    window.location.href = url;
  }

  return (
    <AppContent className='gokada-status'>
      <div className="status-container m-auto mt-3 border-1">
        <h1>Gokada Shipment Status</h1>
        {status && status.url ? (
          <div className="status-general">
            Redirecting to Gokada Shipments Status Page...
          </div>
        ) : status && status.url === '' ? (
          <div className="status-general error">
            {status.message}
          </div>
        ) : <div className="status-general processing">
          Retrieving Gokada Shipment Status...
        </div>}
      </div>
    </AppContent>
  );
};

export default GokadaStatusPage;
